import { getFormattedPrice } from './getFormattedPrice';
import { lookupInventoryCount } from './inventoryKey';

// Builds one wsm-tiles `data` entry for a single vehicle. Pulled out of the
// render tree so the whole tile-data array can be computed once, up front,
// before the single <Tiles type="model" layout="carousel"> call that now
// owns the entire carousel (rather than recomputing this per-tile inside a
// host-owned Slider).
export const buildModelTileData = ({
	vehicle,
	modelLink,
	labels,
	locale,
	inventoryCounts,
	hasInventoryData,
	prefs
}) => {
	const { year, make, model, modelInv, gvBodyStyle, image } = vehicle;
	const {
		startingAtPriceLabel,
		showPricing,
		showInventoryOnLotCount,
		inventoryCountLabel,
		includeDestinationChargeInPrice,
		hideYearMake,
		tileImageVerticalPadding,
		tileDisplayType
	} = prefs;

	const formattedPrice = getFormattedPrice(
		locale,
		includeDestinationChargeInPrice === 'true',
		vehicle
	);

	// Matches the existing (non-tile) carousel card's behavior: the price
	// label shows whenever showPricing is enabled, even if this particular
	// vehicle has no price data (formattedPrice resolves to '').
	const priceLine =
		showPricing === 'true'
			? `${labels.get(startingAtPriceLabel)} ${formattedPrice}`
			: null;

	const inventoryLine =
		showInventoryOnLotCount === 'true' && hasInventoryData
			? `${lookupInventoryCount(
					inventoryCounts,
					model || modelInv,
					gvBodyStyle
			  )} ${labels.get(inventoryCountLabel)}`
			: null;

	// Figma calls for a single line of muted additionalData text per tile --
	// price takes priority whenever showPricing is enabled (regardless of
	// whether this vehicle actually has price data), falling back to the
	// on-lot count only when pricing is disabled outright.
	const additionalData = priceLine || inventoryLine || undefined;

	return {
		model: {
			name: model || modelInv,
			// ModelTile's propTypes expect year as a string; vehicle.year is a
			// number.
			year: year ? String(year) : undefined,
			make,
			imageUrl: image,
			href: modelLink
		},
		hideYearMake: hideYearMake === 'true',
		imageVerticalPadding: tileImageVerticalPadding,
		displayType: tileDisplayType,
		additionalData,
		'data-testid': 'model-card-carousel-component-test'
	};
};
